import { render, staticRenderFns } from "./RedeemHistory.vue?vue&type=template&id=04cc128d&"
import script from "./RedeemHistory.vue?vue&type=script&lang=js&"
export * from "./RedeemHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RedeemHistory.vue"
export default component.exports